module.exports = __webpack_public_path__ + "dc8de993b3fa57c0670bf7ae31b19818.pdf";